import React from 'react'
import { Chip } from 'components/Form'

const TestTakerDetailsStatusCell = (props) => {
    const { row } = props
    const { invalid, dob, language, parent_phone, parent_email, parent_first_name } = row.original

    let errorItem = {
        "NOT_CREATED": {
            label: "לא נוצר - חסר פרטים",
            color: "error"
        },
        "MISSING": {
            label: "חסר פרטים",
            color: "yellow"
        },
        "VALID": {
            label: "תקין",
            color: "green"
        }
    }
    let error = errorItem.VALID

    if (invalid)
        error = errorItem.NOT_CREATED

    else if (!dob || !language || (!parent_phone && !parent_email) || !parent_first_name)
        error = errorItem.MISSING
    


    return (
        !error ||
        <div style={{ display: "flex" }}>
            <Chip color={error.color} >
                {error.label}
            </Chip>
        </div>
    )
}

export default TestTakerDetailsStatusCell